import { PropsWithChildren } from "react";

import styles from "@components/typography/Typography.module.css";

type Props = PropsWithChildren<{
  htmlFor?: string;
}>;

const InputLabel = ({ children, htmlFor }: Props) => (
  <label className={styles.inputLabel} htmlFor={htmlFor}>
    {children}
  </label>
);

export default InputLabel;
